import Enum from './enum'

class RequestState extends Enum
{
  constructor(value) {
    super(value);
  }
}

RequestState.init({
  EMPTY: 'None',
  DRAFT: 'Draft',
  REGISTERED: 'Registred',
  APPROVED: 'Approved',
  CONDITIONALLY_APPROVED: 'ConditionApproved',
  DECLINED: 'Declined',
  DELETED: 'Deleted'
}, {
  EMPTY: 'request-state.empty',
  DRAFT: 'request-state.draft',
  REGISTERED: 'request-state.registered',
  APPROVED: 'request-state.approved',
  CONDITIONALLY_APPROVED: 'request-state.conditionally-approved',
  DECLINED: 'request-state.declined',
  DELETED: 'request-state.deleted'
});

export default RequestState;
